import { render, staticRenderFns } from "./single-time.vue?vue&type=template&id=010a50c0&scoped=true&"
import script from "./single-time.vue?vue&type=script&lang=ts&"
export * from "./single-time.vue?vue&type=script&lang=ts&"
import style0 from "./single-time.vue?vue&type=style&index=0&id=010a50c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010a50c0",
  null
  
)

export default component.exports